import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ToggleSetting from './ToggleSetting';
import AdditionalSources from './AdditionalSources';
import Filters from './Filters';
import SelectSetting from './SelectSetting';
import { getSettings, watchSettings, unwatchSettings } from '../utils/eventViewerSettings';

export default function Settings({
	opened = false,
}){
	const [ showHighlightDiff, setShowHighlightDiff ] = useState(getSettings().cmsWebAsSource);
	useEffect(()=>{
		const handleSettingChange = (newSettings) => {
			if(newSettings.cmsWebAsSource !== showHighlightDiff){
				setShowHighlightDiff(newSettings.cmsWebAsSource);
			}
		}
		watchSettings(handleSettingChange);
		return function cleanup(){
			unwatchSettings(handleSettingChange);
		}
	});

	return (
		opened &&
		<div
			className={[
				'ws-tagging-ev-settings',
				'bg-white',
				'border-bottom',
				'shadow',
				'position-absolute',
				'w-100',
				'px-4',
				'py-2'
			].join(' ')}
		>
			<h3>Settings</h3>
			<ToggleSetting
				setting="promptUnload"
			>
				Prompt to navigate away from / refresh the page
			</ToggleSetting>
			<ToggleSetting
				setting="eventObjectsOpenedByDefault"
			>
				Event objects opened by default
			</ToggleSetting>
			<ToggleSetting
				setting="cmsWebAsSource"
			>
				Show &quot;cms-web&quot; events as it&lsquo;s own source
			</ToggleSetting>
			{
				showHighlightDiff &&
				(
					<ToggleSetting
						setting="cmsWebHighlightDiff"
						className="ml-4"
					>
						Highlight &quot;cms-web&quot; event as the same or different than the &quot;ws-tagging&quot; events
					</ToggleSetting>
				)
			}
			<SelectSetting
				setting="order"
				options={[
					'Newest on top',
					'Oldest on top'
				]}
			 >
				 Event Order:
			</SelectSetting>
			<AdditionalSources />
			<Filters />
		</div>
	)
}

Settings.propTypes = {
	opened: PropTypes.bool
};
